// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"9b07569a3178e1e7f0fd","655":"253dd10cf744e4bb2394"}[chunkId] + ".js";
};